import { useNavigate } from '@remix-run/react'
import { useEffect } from 'react'

import { WIZARD_COOKIES_KEY } from '~/constants/local-storage.client'
import { prepareCookies } from '~/utils/c2c/prepare-cookies'

type C2CNavigateMessage = {
  type: 'c2c:navigate'
  href: string
}

type C2CCookieMessage = {
  type: 'c2c:cookie'
  redirectUrl: string
}

type UseC2CHandlerProps = {
  c2cOrigin: string
  cookiePrefix: string
}

export function useC2CHandler({ c2cOrigin, cookiePrefix }: UseC2CHandlerProps) {
  const navigate = useNavigate()

  useEffect(() => {
    const handleMessage = async (event: MessageEvent): Promise<void> => {
      if (
        typeof event.data !== 'object' ||
        event.data === null ||
        event.origin !== c2cOrigin
      )
        return

      const message = event.data as Partial<
        C2CNavigateMessage | C2CCookieMessage
      >

      if (message.type === 'c2c:navigate') {
        if (typeof message.href !== 'string' || !message.href.startsWith('/'))
          return

        navigate(message.href)
      }

      if (message.type === 'c2c:cookie' && message.redirectUrl) {
        const response = await fetch('/api/wizard/save-cookie', {
          method: 'POST',
          body: JSON.stringify(
            prepareCookies(message.redirectUrl, cookiePrefix)
          )
        })
        const data = await response.json()

        if (data.success) {
          localStorage.setItem(WIZARD_COOKIES_KEY, JSON.stringify(data.cookies))
        }

        window.open(message.redirectUrl, '_top')
      }
    }

    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [navigate, cookiePrefix, c2cOrigin])
}
